import {TableColumn} from '@fl/cmsch-fe-library';

import {FemaleHolsteinAnimalInList} from 'api/gen/FemaleHolsteinAnimalInList';

import {
    booleanColumn,
    dateColumn,
    decimalColumn,
    hyperlinkColumn,
    numberColumn,
    stringColumn,
} from '../../../user/utils/table-columns-helpers';
import {getAnimalBrowserLink} from '../../utils';

export const matingCowsColumns: Array<TableColumn<FemaleHolsteinAnimalInList>> = [
    hyperlinkColumn({
        field: 'earTag',
        width: 150,
        valueToUrl: getAnimalBrowserLink,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'farmCode',
        width: 150,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    dateColumn({field: 'birthDate', width: 150}),
    dateColumn({field: 'lastCalvingAt', width: 150}),
    numberColumn({field: 'lactation', width: 85}),
    dateColumn({field: 'lastMatingDate', width: 80}),
    booleanColumn({field: 'pregnant', width: 85, disableTooltip: true}),
    numberColumn({field: 'lactationDays', width: 85}),
    numberColumn({field: 'milkKg', width: 80}),
    numberColumn({field: 'fatKg', width: 80}),
    decimalColumn({field: 'fatPercentage', width: 80, fixedDecimals: 2}),
    numberColumn({field: 'proteinKg', width: 85}),
    decimalColumn({field: 'proteinPercentage', width: 85, fixedDecimals: 2}),
    numberColumn({field: 'bvMilkKg', width: 100}),
    numberColumn({field: 'bvMilkKgReliability', width: 120}),
    numberColumn({field: 'bvFatKg', width: 80}),
    decimalColumn({field: 'bvFatPercentage', width: 80, fixedDecimals: 2}),
    numberColumn({field: 'bvProteinKg', width: 115}),
    decimalColumn({field: 'bvProteinPercentage', width: 110, fixedDecimals: 2}),
    numberColumn({field: 'sihIndex', width: 65}),
    booleanColumn({field: 'redIndex', width: 65}),
    decimalColumn({field: 'inbreedingCoefficient', width: 100, fixedDecimals: 3, filterTypes: undefined}),
    numberColumn({field: 'rbvMilkKg', width: 95}),
    numberColumn({field: 'rbvFatKg', width: 80}),
    numberColumn({field: 'rbvFatPercentage', width: 80}),
    numberColumn({field: 'rbvProteinKg', width: 120}),
    numberColumn({field: 'rbvProteinPercentage', width: 110}),
    numberColumn({field: 'rbvSomaticCells', width: 65}),
    numberColumn({field: 'rbvClinicalMastitis', width: 65}),
    numberColumn({field: 'rbvLimbDisease', width: 65}),
    numberColumn({field: 'rbvFrame', width: 65}),
    numberColumn({field: 'rbvChestWidth', width: 65}),
    numberColumn({field: 'rbvBodyDepth', width: 65}),
    numberColumn({field: 'rbvEdginess', width: 65}),
    numberColumn({field: 'rbvBackAngle', width: 65}),
    numberColumn({field: 'rbvBackWidth', width: 65}),
    numberColumn({field: 'rbvRearPosture', width: 65}),
    numberColumn({field: 'rbvSidePosture', width: 65}),
    numberColumn({field: 'rbvHoovesAngle', width: 65}),
    numberColumn({field: 'rbvForeUdderAttachment', width: 65}),
    numberColumn({field: 'rbvFrontTeatsPlacement', width: 65}),
    numberColumn({field: 'rbvTeatsLength', width: 65}),
    numberColumn({field: 'rbvUdderDepth', width: 65}),
    numberColumn({field: 'rbvRearUdderAttachmentHeight', width: 65}),
    numberColumn({field: 'rbvSuspensoryLigament', width: 65}),
    numberColumn({field: 'rbvRearTeatsPlacement', width: 65}),
    numberColumn({field: 'rbvRearUdderAttachmentWidth', width: 65}),
    numberColumn({field: 'rbvBonesQuality', width: 65}),
    numberColumn({field: 'rbvWalkQuality', width: 65}),
    numberColumn({field: 'rbvFitness', width: 65}),
    numberColumn({field: 'rbvMilkStrength', width: 85}),
    numberColumn({field: 'milkStrength', width: 60}),
    numberColumn({field: 'rbvBodyStructure', width: 60}),
    numberColumn({field: 'rbvExtremities', width: 60}),
    numberColumn({field: 'rbvUdder', width: 60}),
    numberColumn({field: 'rbvOverallCondition', width: 60}),
    numberColumn({field: 'bodyStructure', width: 60}),
    numberColumn({field: 'extremities', width: 95}),
    numberColumn({field: 'udder', width: 85}),
    stringColumn({field: 'overallClass', width: 80, customFiltersOnly: true, filterTypes: ['containsString', 'null']}),
    numberColumn({field: 'overallCondition', width: 80}),
    stringColumn({
        field: 'genotype',
        width: 60,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'breedAlpha13',
        width: 60,
        sortable: true,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
];
